import sectionReviewVitalCss from '../css-snippets/section-review-vital';

const html = `
<style>${sectionReviewVitalCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-color="#000000" data-text-color="#000000"
  style="background-color: #ffffff; color: #000000; --color-text: #000000; --color-background: #ffffff; --color-star: #214a88;"
  data-img-product-review="https://cdn.skyfastimg.com/images/2026/04/14/image-69dde9b6a000f894ab6ad6e9.jpg"
  data-title-product-review="Reviewing" data-name-product-review="Vital Beauty Collagen Powder Mango Passion - 600g"
  data-avatar-admin="https://cdn.skyfastimg.com/images/2026/04/14/image-69dde73080f52bc5ce3694a6.png?"
  data-name-admin="Simply Nootropics"
  data-payload="[{&quot;id&quot;:1,&quot;name&quot;:&quot;Kelly G.&quot;,&quot;avatar&quot;:&quot;https://cdn.skyfastimg.com/images/2026/04/14/image-69dde76d2cb4e34824092c80.webp&quot;,&quot;stars&quot;:5,&quot;title&quot;:&quot;Excellent taste&quot;,&quot;results&quot;:5,&quot;easeOfUse&quot;:5,&quot;taste&quot;:5,&quot;content&quot;:&quot;I am ready to subscribe to this product! I tried it for a month, and I have used several other collagen supplements as my hair and nails have always been brittle. This one is the winner! My skin glows! It tastes so good, and it works! Buy it! You won’t be disappointed!&quot;,&quot;media&quot;:{&quot;img&quot;:[{&quot;url&quot;:&quot;https://cdn.skyfastimg.com/images/2026/04/14/image-69dde7d8405da267c43fdccb.webp?w=50&h=50&q=80&quot;},{&quot;url&quot;:&quot;https://cdn.skyfastimg.com/images/2026/04/14/image-69dde7db3221ba7f92e0974b.webp?w=50&h=50&q=80&quot;}]},&quot;replies&quot;:[{&quot;content&quot;:&quot;Thank you so much for your glowing feedback! We're thrilled that our products are fueling your energy and making such a positive difference in your life. We appreciate you spreading the word!&quot;}],&quot;like&quot;:1,&quot;dislike&quot;:0}]"
  data-page-limit="5">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div data-show-title="false" data-attribute="title-card" class="title-card"></div>
      <div class="block-rated-results">
        <div class="left-result">
          <div class="title-result-left">
            <div data-attribute="average-rating" data-value="4.8" class="average-rating">4.8</div>
            <!-- svg star -->
            <div class="svg-average-rating">
              <div class="mask-star">
                <div data-attribute="percent-rating-star" data-value="96%" style="width: 96%;"
                  class="average-rating-star"></div>
              </div>
            </div>
            <div data-attribute="text-result" data-value="1121" class="text-result">Based on <span
                data-attribute="total-reviews">10</span> reviews</div>
          </div>
          <div class="wrap-items">
            <div data-attribute="5-star" class="wrap-star-rating">
              <div class="item-star-1">
                <span>5</span>
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="item-star-2">
                <div data-attribute="percent-score-5-star" data-value="10" style="width: 10%;"
                  class="progress-bar-rating"></div>
              </div>
              <div data-attribute="score-star-5" data-value="959" class="score-star">959</div>
            </div>
            <div data-attribute="4-star" class="wrap-star-rating">
              <div class="item-star-1">
                <span>4</span>
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="item-star-2">
                <div data-attribute="percent-score-4-star" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div data-attribute="score-star-4" data-value="959" class="score-star">959</div>
            </div>
            <div data-attribute="3-star" class="wrap-star-rating">
              <div class="item-star-1">
                <span>3</span>
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="item-star-2">
                <div data-attribute="percent-score-3-star" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div data-attribute="score-star-3" data-value="959" class="score-star">959</div>
            </div>
            <div data-attribute="2-star" class="wrap-star-rating">
              <div class="item-star-1">
                <span>2</span>
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="item-star-2">
                <div data-attribute="percent-score-2-star" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div data-attribute="score-star-2" data-value="959" class="score-star">959</div>
            </div>
            <div data-attribute="1-star" class="wrap-star-rating">
              <div class="item-star-1">
                <span>1</span>
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                    fill="currentColor" />
                </svg>
              </div>
              <div class="item-star-2">
                <div data-attribute="percent-score-1-star" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div data-attribute="score-star-1" data-value="959" class="score-star">959</div>
            </div>
          </div>
        </div>
        <div class="right-result">
          <div class="title-result-right"><span data-value="98%" class="percent-recommend-product"
              data-attribute="percent-score-recommend-product">98%</span> would
            recommend these products</div>
          <div class="wrap-chart-recommend-product">
            <div class="rating-scale">
              <div class="title-scale">Results</div>
              <div class="wrap-slider-core">
                <div class="slider-core"></div>
                <div class="list-dot">
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                </div>
                <div data-attribute="percent-score-result" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div class="text-start-end-slider">
                <div class="text-item">Poor</div>
                <div class="text-item">Excellent</div>
              </div>
            </div>
            <div class="rating-scale">
              <div class="title-scale">Ease of Use</div>
              <div class="wrap-slider-core">
                <div class="slider-core"></div>
                <div class="list-dot">
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                </div>
                <div data-attribute="percent-score-ease-of-use" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div class="text-start-end-slider">
                <div class="text-item">Poor</div>
                <div class="text-item">Excellent</div>
              </div>
            </div>
            <div class="rating-scale">
              <div class="title-scale">Taste Rated</div>
              <div class="wrap-slider-core">
                <div class="slider-core"></div>
                <div class="list-dot">
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                  <div class="dot-item"></div>
                </div>
                <div data-attribute="percent-score-taste" data-value="90" style="width: 90%;"
                  class="progress-bar-rating"></div>
              </div>
              <div class="text-start-end-slider">
                <div class="text-item">Poor</div>
                <div class="text-item">Excellent</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-slider">
        <div class="swiper swiper-slider-unique-id">
          <div data-attribute="list-item-slider" class="swiper-wrapper">
          </div>
        </div>
      </div>
      <div class="block-reviews">
        <div class="header-review">
          <div class="border-title">
            <div class="title-small-reviews">Reviews</div>
          </div>

          <div class="filter-review">

            <!-- stars filter -->
            <div data-attribute="stars-filter" data-value="5" class="wrap-stars-icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div data-attribute="stars-filter" data-value="4" class="wrap-stars-icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div data-attribute="stars-filter" data-value="3" class="wrap-stars-icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div data-attribute="stars-filter" data-value="2" class="wrap-stars-icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
            </div>

            <div data-attribute="stars-filter" data-value="1" class="wrap-stars-icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                  fill="currentColor" />
              </svg>
            </div>

          </div>
        </div>
        <div data-attribute="list-item-review" class="list-reivews">

        </div>
        <div data-attribute="view-more-review" class="view-more-review">
          Show more
        </div>
      </div>
    </div>
  </div>
  <div data-attribute="modal-preview" data-id="modal-preview-unique-id" class="modal-preview">
    <div class="content-preview">
      <div data-attribute="close-preview" class="close-preview">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="wrap-content-preview">
        <div class="left-content-preview">
          <!-- <div class="image-preview">
            <img data-attribute="img-user-upload" src="" alt="">
          </div> -->
          <div class="swiper swiper-zoom-preview">
            <div data-attribute="list-item-zoom-preview" class="swiper-wrapper">

            </div>
          </div>
          <div class="swiper swiper-thumb-preview">
            <div data-attribute="list-item-thumb-preview" class="swiper-wrapper">

            </div>
          </div>
        </div>
        <div class="right-content-preview">
          <div class="block-user">
            <div class="avatar-user">
              <img data-attribute="avatar-user" src="" alt="">
            </div>
            <div class="name-user">
              <div data-attribute="user-name" class="name-user-text"></div>
              <div class="verified-user">
                <span>Verified Buyer</span>
                <span class="icon-check">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div class="reviewed-product">
            <div class="img-product">
              <img data-attribute="img-product" src="" alt="">
            </div>
            <div class="text-reviewed-product">
              <div data-attribute="title-reviewed-product" class="title-reviewed-product"></div>
              <div data-attribute="name-product" class="name-product"></div>
            </div>
          </div>
          <!-- svg star -->
          <div class="svg-average-rating">
            <div class="mask-star">
              <div data-attribute="percent-rating-star" data-value="96%" style="width: 96%;"
                class="average-rating-star">
              </div>
            </div>
          </div>
          <div class="content-review">
            <div data-attribute="title-review" class="title-review"></div>
            <div data-attribute="content-review-text" class="content-review-text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


`;
export default html;
